const initialState = {
  isLoading: false,
  error: '',
};

export const getInterviewTestRequest = (state) => ({
  ...state,
  isLoading: true,
  error: '',
});

export const getInterviewTestSuccess = (state) => {
  return {
    ...state,
    isLoading: false,
    error: '',
  };
};

export const getInterviewTestFailure = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    error: payload,
  };
};

export default initialState;
